const ProcessingMultilineHeadline: Array<{ headline: string }> = [
  {
    headline: "we are",
  },
  {
    headline: "processing your",
  },
  {
    headline: "request...",
  },
];

const ProcessingHeadline = "We are processing your request...";

export default ProcessingMultilineHeadline;
export { ProcessingHeadline, ProcessingMultilineHeadline };
